<template>
  <div class="meal-box">
    <div class="meal">
      <div class="meal-name-hour">
        <div class="meal-name">{{ meal.name }}</div>
        <div class="meal-hour">{{ meal.hour }}</div>
      </div>
      <div class="meal-dishes-and-ingredients">
        <div
          v-for="(name, index) in meal.dishesAndIngredients"
          :key="index"
          class="meal-dish-or-ingredient"
        >
          <span>
            {{ name }}
            <template v-if="meal.dishesAndIngredients.length > 3 && index === 2">...</template>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { DietMealViewModel } from '../../types'

  defineProps<{ meal: DietMealViewModel['meal'] }>()
</script>
